import { gql } from '@apollo/client'

// Query to get a list of creditors based on filters
export const CREDITORS_QUERY = gql`
  query Creditors($filters: CreditorFilters!) {
    creditors(filters: $filters) {
      walletID
      creditorID
      entity {
        entityType
        entityID
        entityCode
        entityName
      }
      walletBalance
      remainingCreditBalance
      remainingReservable
      active
      autoSettelmentEnabled
      maxCredit
    }
  }
`
